module.exports = __webpack_public_path__ + "static/img/goodness1.d6224757.png";